export const pinterestCarouselId = "pinterest";
